import { render } from "./move_header.vue?vue&type=template&id=40f952db&scoped=true"
import script from "./move_header.vue?vue&type=script&lang=js"
export * from "./move_header.vue?vue&type=script&lang=js"

import "./move_header.vue?vue&type=style&index=0&id=40f952db&scoped=true&lang=less"

import exportComponent from "D:\\STD7159\\源码管理\\前端\\stgd.oa.ows.inernetweb\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40f952db"]])

export default __exports__